import RouterMap from "../modules/routerMap";

window["fw_theme"] = function () {
	return "cosmote";
};
window["fw_routerMap"] = RouterMap;

// TEMP MOCK - REMOVE BEFORE DELIVERY
// window.__MI_USE_LOCAL_MOCK__ = true;
// window.__MI_MOCK_ENDPOINTS__ = {
// 	// ! shared mocks (same across all scenarios)
// 	// "/service/checkOrderStatus": "/mock/orderStatus/checkOrderStatusPending.json",
// 	"/service/checkOrderStatus":
// 		"/mock/orderStatus/checkOrderStatusNotPending.json",
// 	"/service/getRORCharge": "/mock/getRORCharge.json",
// 	"/page/submitService": "/mock/submitService.json",
// 	"/page/submitBillService": "/mock/submitService.json",
// 	"/service/getLastOrderStatus": "/mock/getLastOrderStatus.json",
// 	"/service/getLastPrepaidOrderStatus": "/mock/getLastPrepaidOrderStatus.json",
// 	// ! prepaid mocks - PREPAID_COSMOKARTA_FA_LOW_BALANCE (Cosmokarta, FA mode, 5.50 balance, expensive packs blocked)
// 	// "/page/land": "/mock/prepaid/PREPAID_COSMOKARTA_FA_LOW_BALANCE/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/prepaid/PREPAID_COSMOKARTA_FA_LOW_BALANCE/getCustomerData.json",
// 	// ! prepaid mocks - PREPAID_COSMOKARTA_FA (Cosmokarta, FA mode, no active IMP)
// 	// "/page/land": "/mock/prepaid/PREPAID_COSMOKARTA_FA/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/prepaid/PREPAID_COSMOKARTA_FA/getCustomerData.json",
// 	// ! prepaid mocks - PREPAID_COSMOKARTA
// 	// "/page/land": "/mock/prepaid/PREPAID_COSMOKARTA/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/prepaid/PREPAID_COSMOKARTA/getCustomerData.json",
// 	// ! prepaid mocks - NEO_FA_ACTIVE (NEO, FA mode, 200GB balance, no packages)
// 	// "/page/land": "/mock/prepaid/NEO_FA_ACTIVE/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/prepaid/NEO_FA_ACTIVE/getCustomerData.json",
// 	// ! error mocks - MissingHeaders (Wi-Fi / off-network error page)
// 	// "/page/land": "/mock/MissingHeaders/land.json",
// 	// ! prepaid mocks - PREPAID_COSMOKARTA_FA_ACTIVE (Cosmokarta, FA mode)
// 	// "/page/land": "/mock/prepaid/PREPAID_COSMOKARTA_FA_ACTIVE/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/prepaid/PREPAID_COSMOKARTA_FA_ACTIVE/getCustomerData.json",
// 	// ! hybrid mocks - HYBRID_BUSINESS_COST_CONTROL_WITH_MB
// 	// "/page/land": "/mock/hybrid/land.json",
// 	// "/service/getCustomerData": "/mock/hybrid/getCustomerData.json",
// 	// "/page/creditSubmitService": "/mock/hybrid/creditSubmitService.json",
// 	// ! hybrid mocks - HYBRID_RESIDENTIAL_CC_FA (Residential cost control, FA mode, NINJAR, 0 MB)
// 	// "/page/land": "/mock/hybrid/HYBRID_RESIDENTIAL_CC_FA/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/hybrid/HYBRID_RESIDENTIAL_CC_FA/getCustomerData.json",
// 	// ! hybrid mocks - HYBRID_RESIDENTIAL_CC_FA_WITH_MB (duplicate of WAVE 2 — kept for ref)
// 	// "/page/land": "/mock/hybrid/HYBRID_RESIDENTIAL_CC_FA_WITH_MB/land.json",
// 	// "/service/getCustomerData":
// 	// 	"/mock/hybrid/HYBRID_RESIDENTIAL_CC_FA_WITH_MB/getCustomerData.json",
// 	// ! whatsUp mocks - PREPAID_WHATSUP (whatsUp theme, basic)
// 	// "/page/land": "/mock/whatsup/land.json",
// 	// "/service/getCustomerData": "/mock/whatsup/getCustomerData.json",
// 	// ! whatsUp mocks - PREPAID_WHATSUP_FA (FA mode, 40€ balance, GIGA Month + week/hour packs)
// 	"/page/land": "/mock/whatsup/PREPAID_WHATSUP_FA/land.json",
// 	"/service/getCustomerData":
// 		"/mock/whatsup/PREPAID_WHATSUP_FA/getCustomerData.json",
// 	// ! frog mocks - userA (PREPAID_FROG, FA mode, no active IMP)
// 	// "/page/land": "/mock/frog/userA/land.json",
// 	// "/service/getCustomerData": "/mock/frog/userA/getCustomerData.json",
// 	// ! frog mocks - userB (PREPAID_FROG, FA mode, no active IMP)
// 	// "/page/land": "/mock/frog/userB/land.json",
// 	// "/service/getCustomerData": "/mock/frog/userB/getCustomerData.json",
// 	// ! prepaid mocks - PREPAID_COSMOKARTA_NLP (PREPAID_COSMOKARTA, NLP mode, no internet)
// 	// "/page/land": "/mock/prepaid/PREPAID_COSMOKARTA_NLP/land.json",
// 	// ! postpaid mocks - POSTB_GIGAMAX_20GB_ACTIVE (Business Gigamax 8GB, active IMP, 20GB/10GBx2 confirm)
// 	// "/page/land": "/mock/postpaid/POSTB_GIGAMAX_20GB_ACTIVE/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTB_GIGAMAX_20GB_ACTIVE/getContractAvailableServices.json",
// 	// "/service/getAvailableMB":
// 	// 	"/mock/postpaid/POSTB_GIGAMAX_20GB_ACTIVE/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/creditSubmitService.json",
// 	// ! postpaid mocks - POSTB_MI_30GB_GIGA_NOW (POSTB MI 30GB, BFA, no IMP, GIGA NOW Week Unlimited balance)
// 	// "/page/land": "/mock/postpaid/POSTB_MI_30GB_GIGA_NOW/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTB_MI_30GB_GIGA_NOW/getContractAvailableServices.json",
// 	// "/service/getAvailableMB":
// 	// 	"/mock/postpaid/POSTB_MI_30GB_GIGA_NOW/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTB_MI_30GB/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_MI_30GB_GIGA_NOW/creditSubmitService.json",
// 	// ! postpaid mocks - POSTB_MI_30GB (Business Mobile Internet 30GB, no IMP)
// 	// "/page/land": "/mock/postpaid/POSTB_MI_30GB/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTB_MI_30GB/getContractAvailableServices.json",
// 	// "/service/getAvailableMB": "/mock/postpaid/POSTB_MI_30GB/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTB_MI_30GB/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_MI_30GB/creditSubmitService.json",
// 	// ! postpaid mocks - POSTB_ACTIVE (Business GIGAMAX 8GB, active IMP)
// 	// "/page/land": "/mock/postpaid/POSTB_ACTIVE/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/getContractAvailableServices.json",
// 	// "/service/getAvailableMB": "/mock/postpaid/POSTB_ACTIVE/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/creditSubmitService.json",
// 	// ! postpaid mocks - POSTB_UNLIMITED_ACTIVE (Mobile Internet Unlimited)
// 	// "/page/land": "/mock/postpaid/POSTB_UNLIMITED_ACTIVE/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTB_UNLIMITED_ACTIVE/getContractAvailableServices.json",
// 	// "/service/getAvailableMB":
// 	// 	"/mock/postpaid/POSTB_UNLIMITED_ACTIVE/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTB_UNLIMITED_ACTIVE/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/creditSubmitService.json",
// 	// ! postpaid mocks - POSTR_FAMILY_ACTIVE (GIGAMAX Family L)
// 	// "/page/land": "/mock/postpaid/POSTR_FAMILY_ACTIVE/land.json",
// 	// "/service/getContractAvailableServices":
// 	// 	"/mock/postpaid/POSTR_FAMILY_ACTIVE/getContractAvailableServices.json",
// 	// "/service/getAvailableMB":
// 	// 	"/mock/postpaid/POSTR_FAMILY_ACTIVE/getAvailableMB.json",
// 	// "/service/getNextBillingDate":
// 	// 	"/mock/postpaid/POSTR_FAMILY_ACTIVE/getNextBillingDate.json",
// 	// "/page/creditSubmitService":
// 	// 	"/mock/postpaid/POSTB_ACTIVE/creditSubmitService.json",
// };

// window.__MI_GET_MOCK_URL__ = function (url) {
// 	if (!window.__MI_USE_LOCAL_MOCK__ || !url) return null;

// 	let normalizedUrl = String(url);
// 	if (normalizedUrl.startsWith(window.location.origin)) {
// 		normalizedUrl = normalizedUrl.slice(window.location.origin.length);
// 	}
// 	if (normalizedUrl.startsWith("/api")) {
// 		normalizedUrl = normalizedUrl.slice(4);
// 	}
// 	const path = normalizedUrl.split("?")[0];

// 	return window.__MI_MOCK_ENDPOINTS__[path] || null;
// };

// if (!window.__MI_ORIGINAL_FETCH__) {
// 	window.__MI_ORIGINAL_FETCH__ = window.fetch.bind(window);
// 	window.fetch = function (input, init) {
// 		const url = typeof input === "string" ? input : input && input.url;
// 		const mockUrl = window.__MI_GET_MOCK_URL__(url);

// 		if (mockUrl) {
// 			return window.__MI_ORIGINAL_FETCH__(mockUrl, { method: "GET" });
// 		}

// 		return window.__MI_ORIGINAL_FETCH__(input, init);
// 	};
// }
